// Footer Section
const Footer = () => {
    return(
        <footer>
            <p>🏅 Created at Juno College of Technology🏅</p>
        </footer>
    );
}

export default Footer;